import Vue from 'vue'
import Router from 'vue-router'

const ErrorInfo = resolve => require(['zmfront-framework/src/components/404/404page.vue'], resolve);
const Developing = resolve => require(['@/components/Developmenting/404.vue'], resolve);
const ViewPdf = resolve => require(['@/components/viewPDF/index.vue'], resolve);

const Login = resolve => {
    if( process.env.HOST() == "ddsprod" || process.env.HOST() == "ddstemp"){
        require(['@/pages/Login/ddsLogin.vue'], resolve)
    }else if(process.env.HOST() == "kparcel" ){
        require(['@/pages/Login/tmskparcelLogin.vue'], resolve)
    } else {
        require(['@/pages/Login/login0108.vue'], resolve)
        // require(['@/pages/Login/Login.vue'], resolve)  ||  process.env.HOST() == "localhost"
    }
    // if(process.env.HOST() == "kparcel"){
    //     require(['@/oms/login/kparcelLogin.vue'], resolve)
    // }else{
    //     require(['@/oms/login/omsLogin.vue'], resolve)
    // }
};

const VipLogin = resolve => {
    if( process.env.HOST() == "kparcel"){
        require(['@/oms/login/kparcelLogin.vue'], resolve);
    }else{
        require(['@/oms/login/omsLogin.vue'], resolve);
    }
}
/*
const VipLogin = resolve => {
    if(process.env.HOST() == "dev" || process.env.HOST() == "localhost" || process.env.HOST() == "test" || process.env.HOST() == "hxuprod"
        || process.env.HOST() == "hxutemp" || process.env.HOST() == "gyeprod"|| process.env.HOST() == "gyetemp" || process.env.HOST() == "yheprod" || process.env.HOST()== "yhetemp"){
        require(['@/oms/login/login0320.vue'], resolve)
    }else{
        require(['@/oms/login/login.vue'], resolve)
    }
};
*/



const DDSLogin = resolve => require(['@/pages/Login/ddsLogin.vue'], resolve);
const GYELogin = resolve => require(['@/pages/Login/gyeLogin.vue'], resolve);
const Login0108 = resolve => require(['@/pages/Login/login0108.vue'], resolve);
const TMSkparcelLogin = resolve => require(['@/pages/Login/tmskparcelLogin.vue'], resolve);


const OmsLogin = resolve => require(['@/oms/login/login.vue'], resolve);
const OutTrack = resolve => require(['@/oms/customer/problem/outtrackquery.vue'], resolve);
const Login0320 = resolve => require(['@/oms/login/login0320.vue'], resolve);
const kparcelLogin = resolve => require(['@/oms/login/kparcelLogin.vue'], resolve);

const ResetPassword = resolve => require(['@/pages/Login/resetPassword.vue'], resolve);
Vue.use(Router);

export default new Router({

    mode: 'history',
    routes: [
        {path: '/login',name: 'login',component: Login},
        {path: '/ddslogin',name: 'ddslogin',component: DDSLogin},
        {path: '/gyelogin',name: 'gyelogin',component: GYELogin},
        {path: '/viplogin',name: 'omslogin',component: VipLogin},
        // {path: '/kparcelLogin',name: 'omslogin',component: kparcelLogin},
        {path: '/resetPassword',name: 'resetPassword',component: ResetPassword},

        // {path: '/tmskparcelLogin',name: 'kparcellogin',component: TMSkparcelLogin},

        
        // {path: '/404page',name: '404page',component: ErrorInfo},
        {path: '/404page',name: 'developing',component: Developing},
        {path: '/outtrack',name: 'outtrack',component: OutTrack},
        {path: '/viewpdf',name: 'viewPdf',component: ViewPdf},

    ]


})



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/router/index.js